export default {
  eyebrow: "we've done the homework",
  heading: 'See our picks for the best credit cards in every category.',
  links: {
    balanceLink:
      '/best/credit-cards/balance-transfer/?trk=hp_bestcards_balancetransfercards&trk_copy=hpbalancetransfercards',
    lowInterestLink:
      '/best/credit-cards/low-interest/?trk=hp_bestcards_lowinterestcards&trk_copy=hplowinterestcards',
    travelLink:
      '/best/credit-cards/travel/?trk=hp_bestcards_travelcards&trk_copy=hptravelcards',
    cashBackLink:
      '/best/credit-cards/cash-back/?trk=hp_bestcards_cashbackcards&trk_copy=hpcashbackcards',
    rewardsLink:
      '/best/credit-cards/rewards/?trk=hp_bestcards_rewardscards&trk_copy=hprewardscards',
  },
};
